module.exports = "precision mediump float;\nvarying vec3 position;\nvarying vec3 normal;\n\n#ifdef VERT\n\nattribute vec3 p;\nattribute vec3 n;\nuniform mat4 proj;\nuniform mat4 view;\n\nvoid main()\n{\n\tnormal = mat3(view)*n;\n\tvec4 pos = view*vec4(p, 1.0);\n\tposition = pos.xyz;\n\tgl_Position = proj*pos;\n}\n\n#else\n\nuniform vec3 light; // 0.17, -0.17, 0.33\nuniform vec4 color; // 1, 1, 1, 1\n\nvoid main()\n{\n\tvec3 n = normalize(normal);\n\tfloat diff = max(0.0, dot(n, light))*0.9 + 0.1;\n\tgl_FragColor = vec4(color.rgb*diff, color.a);\n}\n\n#endif\n"


//////////////////
// WEBPACK FOOTER
// ./client/shaders/rock.glsl
// module id = 17
// module chunks = 0